import { KeyRound } from "lucide-react";
import { cn } from "@/lib/utils";
import { TipChip } from "@/components/ui/HoverTip";
import { ELEMENT_TAGS, TAG_ORDER } from "./element-tags";

const CHIP =
  "inline-flex shrink-0 items-center rounded border px-1.5 py-0.5 text-[9.5px] font-bold uppercase tracking-[0.03em]";

/**
 * What the four tags mean, in the attorney's own terms, behind the Key pill at
 * the end of the heading, as the design draws a key.
 *
 * Every definition says whether action is needed, so the consequence of a tag is
 * never left to be inferred from its colour. Both the definitions and the colours
 * come from the one tag table, so this key and the cards cannot disagree.
 */
export function ElementKey() {
  return (
    <span className="ml-auto">
      <TipChip
        label="Key"
        chip="key"
        icon={<KeyRound aria-hidden />}
        align="end"
        testId="element-key"
        tip={
          <dl className="space-y-2.5">
            {TAG_ORDER.map((id) => {
              const tag = ELEMENT_TAGS[id];
              return (
                <div key={id} className="flex items-start gap-2.5">
                  <dt className={cn(CHIP, tag.chipClass)}>{tag.label}</dt>
                  <dd className="text-[11.5px] leading-relaxed text-muted-foreground">
                    {tag.definition}
                  </dd>
                </div>
              );
            })}
          </dl>
        }
      />
    </span>
  );
}
